import React, { PureComponent } from 'react';
import { func, string, number } from 'prop-types';
import classnames from 'classnames';
import MediaQuery from 'react-responsive';
import { withFeatureFlags } from 'connectors';
import History from '../History/History';
import Trends from '../Trends/Trends';
import Merchandising from '../Merchandising/Merchandising';

import './Proposals.scss';

class Proposals extends PureComponent {
    static propTypes = {
        className: string,
        onTrendSelected: func.isRequired,
        onHistorySelected: func.isRequired,
        closeProposals: func.isRequired,
        mobileWidth: number.isRequired,
    };

    static defaultProps = {
        className: null,
    };

    handleHistorySelected = value => {
        this.props.onHistorySelected(value);
    };

    render() {
        const {
            onTrendSelected,
            className,
            closeProposals,
            mobileWidth,
        } = this.props;
        const rootClassnames = classnames('searchBar__proposals', className);

        return (
            <div className={rootClassnames}>
                <MediaQuery maxWidth={mobileWidth}>
                    {matches =>
                        matches ? (
                            <div className="searchBar__close-mobile">
                                <button
                                    className="searchBar__close-mobile__button"
                                    onClick={closeProposals}
                                >
                                    Fermer
                                </button>
                            </div>
                        ) : (
                            <div className="searchBar__close-desktop">
                                <button
                                    className="searchBar__close-desktop__button"
                                    onClick={closeProposals}
                                >
                                    <i className="icon icon__close searchBar__close-desktop__button__icon" />
                                    Fermer
                                </button>
                            </div>
                        )
                    }
                </MediaQuery>

                <div className="searchBar__history-and-trends">
                    <History
                        className="searchBar__history"
                        onHistorySelected={this.handleHistorySelected}
                    />

                    <Trends
                        className="searchBar__trends"
                        onTrendSelected={onTrendSelected}
                    />
                </div>
                <Merchandising className="searchBar__categories" />
            </div>
        );
    }
}

export default withFeatureFlags({
    mobileWidth: 'instantSearch.old.mobileWidth',
})(Proposals);
